const sortNumericString = (a, b) => {
  const aa = Number(a);
  const bb = Number(b);

  if (aa < bb) return 1;
  if (aa > bb) return -1;
  return 0;
};

export const getTimelineYearsSortedByYearDesc = (timelineYears = []) => {
  return timelineYears.map((timelineYear) => timelineYear.name).sort(sortNumericString);
};
